import React from "react";

import cx from "classnames";

import { Alert, AlertText } from "../Alert";

import styles from "./Toast.scss";

export function Toast({
  variant = "info",
  text,
  content,
  className,
  dismiss,
  going = false,
  ...wrapperProps
}: {
  variant?: "success" | "info" | "warning" | "default";
  text?: AlertText;
  content?: string | React.ReactNode;
  className?: string;
  dismiss?: () => void;
  /**
   * Animates the toast dismissal when true.
   */
  going?: boolean;
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
}) {
  return (
    <div
      data-testid="toast"
      role="status"
      className={cx(styles.toast, className, {
        [styles.going]: going,
      })}
      {...wrapperProps}
    >
      <Alert variant={variant} onDismiss={dismiss} text={text}>
        {content}
      </Alert>
    </div>
  );
}
